<!-- @component A rectangular element with centered content and variants for loading and errors. -->
<script lang="ts">
  import clsx from "clsx";

  import Loading from "./Loading.svelte";

  export let title: string = "";
  export let variant: "normal" | "error" = "normal";
  export let loading: boolean = false;
</script>

<div
  class={clsx(
    "border rounded-lg h-56 flex justify-center items-center",
    variant === "normal" && "border-zinc-700 bg-[#202224]",
    variant === "error" && "border-red-700 bg-[#421a18]",
  )}
>
  <div
    class={clsx(
      "space-y-2 text-center p-4",
      variant === "normal" && "text-zinc-300",
      variant === "error" && "text-red-300",
    )}
  >
    {#if loading}
      <Loading class="w-6 h-6" />
    {:else}
      {#if title}<p class="text-lg font-medium">{title}</p>{/if}
      <slot />
    {/if}
  </div>
</div>
